import { useMemo } from 'react'
import { Role } from '@wove/common/roles'
import useUserStore from '@src/state/user'

export const useRequiredRoles = (requiredRoles: Role[]) => {
  const user = useUserStore((state) => state.user)
  const role = useUserStore((state) => state.role)
  
  const hasRole = useMemo(() => {
    if (!role) return false
    
    return requiredRoles.includes(role as Role)
  }, [role, requiredRoles])

  const userRole = role as Role | undefined

  return {
    hasRole,
    userRole,
    isLoading: !user && useUserStore.getState().authed === false,
  }
}